import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILED,
  DUPLICATE,
  REMOVE,
  REMOVE_SUCCESS,
  REMOVE_FAILED,
} from './constants';

export interface InitAction {
  type: typeof INIT;
  data: { id: string; cause?: any };
}
export const initAction = (data: { id: string; cause?: any }): InitAction => ({
  type: INIT,
  data,
});

interface InitSuccessAction {
  type: typeof INIT_SUCCESS;
}
export const initSuccessAction = (): InitSuccessAction => ({
  type: INIT_SUCCESS,
});

interface InitFailedAction {
  type: typeof INIT_FAILED;
  error: Error;
}
export const initFailedAction = (error: Error): InitFailedAction => ({
  type: INIT_FAILED,
  error,
});

export interface SaveAction {
  type: typeof SAVE;
  data: any;
}
export const saveAction = (data: any): SaveAction => ({
  type: SAVE,
  data,
});

export interface RemoveAction {
  type: typeof REMOVE;
  causeId: string;
}

export const removeAction = (causeId: string): RemoveAction => ({
  type: REMOVE,
  causeId,
});

export interface RemoveSuccessAction {
  type: typeof REMOVE_SUCCESS;
}

export const removeSuccessAction = (): RemoveSuccessAction => ({
  type: REMOVE_SUCCESS,
});

export interface RemoveFailedAction {
  type: typeof REMOVE_FAILED;
  error: any;
  errorCode: string;
}

export const removeFailedAction = (
  error: any,
  errorCode: string,
  additional?: any
): RemoveFailedAction => ({
  type: REMOVE_FAILED,
  error,
  errorCode,
  ...additional,
});

interface SaveSuccessAction {
  type: typeof SAVE_SUCCESS;
}
export const saveSuccessAction = (): SaveSuccessAction => ({
  type: SAVE_SUCCESS,
});

interface SaveFailedAction {
  type: typeof SAVE_FAILED;
  error: Error;
  errorCode: string;
}
export const saveFailedAction = (error: Error, errorCode: string): SaveFailedAction => ({
  type: SAVE_FAILED,
  error,
  errorCode,
});

export interface DuplicateAction {
  type: typeof DUPLICATE;
  data: any;
}
export const duplicateAction = (data: any): DuplicateAction => ({
  type: DUPLICATE,
  data,
});

export type CauseFormPageActions =
  | InitAction
  | InitSuccessAction
  | InitFailedAction
  | SaveAction
  | SaveSuccessAction
  | SaveFailedAction
  | DuplicateAction
  | RemoveAction
  | RemoveSuccessAction
  | RemoveFailedAction;
